export const SUBJECT_AREAS_OPTIONS = [
  'Medical Technologies',
  'Biomedical Imaging',
  'Medical Interventions',
  'Nanotechnology in Biomedicine',
  'Biomaterials',
  'Systems Biology',
  'Physical Measurements',
  'Bioinformatics'
];
